/**
 * Feature-detected service worker registration (spec 04). On iOS 10 and other
 * SW-less browsers this is a no-op and the app stays fully usable online.
 * Registers the built /sw.js directly (no vite-plugin-pwa virtual module) so the
 * dev server doesn't need the SW graph.
 */

export const swSupported = 'serviceWorker' in navigator;

let updateReady = false;
const listeners = new Set<() => void>();

export function registerServiceWorker(): void {
  if (!swSupported || import.meta.env.DEV) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { type: 'module' })
      .then((reg) => {
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          installing?.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              updateReady = true;
              listeners.forEach((l) => l());
            }
          });
        });
      })
      .catch(() => {
        /* SW registration failed — app still works online */
      });
  });
}

export function isUpdateReady(): boolean {
  return updateReady;
}

export function applyServiceWorkerUpdate(): void {
  location.reload();
}

export function onUpdateReady(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
